import { Component, Input } from '@angular/core';

@Component({
   selector: 'samweb-unread-messages-badge',
   templateUrl: './unread-messages-badge.component.html',
   styleUrls: ['./unread-messages-badge.component.scss'],
})
export class UnreadMessagesBadgeComponent {
   @Input()
   public numberOfUnreadMessages: number;

   @Input()
   public showNumber: boolean;
}
